import { useQuery } from '@tanstack/react-query';
import { getProtocolDetailsByObjId } from 'api/auth.api';

export const useProtocolDetailsByObjId = (id) => {
  return useQuery({
    queryKey: ['protocolDetailsByObjId', id],
    queryFn: () => getProtocolDetailsByObjId(id),
    enabled: !!id,
    select: (res) => res?.data?.result,
  });
};
